import { Vue, Component, Mixins, Watch } from 'vue-property-decorator';
import TrackMixin from './FlashTrackMixin';
import StaticImage from '@/modules/common/StaticImage.vue';
import StaticCode from '../../flashcode/components/StaticCode.vue';
import StaticSwiper from '../../flashcode/components/StaticSwiper.vue';
import StaticGif from '@/modules/common/StaticGif.vue';
import toast, { ToastType } from '@/basic/components/Toast';
import Observer from '../single/Observer';
import {
  BottomType,
  IFreeChageRes,
  IApplyConfig,
  IPageConfig,
  IBottom,
  IBottomConfig,
  IUserInfo,
} from '../types';
import { handleIframePayment, handlePayment } from '@/modules/common/helps';
import { promiseLock } from '@/lib/decorates';
import { PayChannel } from '@/lib/pingpp';
import Closure2TrackerMixin from './Closure2TrackerMixin';
import StayStrategyMixin from './StayStrategyMixin';
import {
  IPayType,
  PayTypes,
  IHuabeiTermInfo,
} from '@/modules/common/MutiPayChannel';

import QuestionnairePy from '../components/Questionaire/QuesPy.vue';
import QuestionnaireNormal from '../components/Questionaire/QuesNormal.vue';
import { hexToRgba } from '../utils/hexToRgb';
import { getQueryFromSearch } from '@/lib/util';
@Component({
  components: {
    QuestionnaireNormal,
    QuestionnairePy,
  },
})
export default class Enrollment extends Mixins(
  TrackMixin,
  Closure2TrackerMixin,
  StayStrategyMixin
) {
  compMap = {
    image: StaticImage,
    'flash-code': StaticCode,
    gif: StaticGif,
    swiper: StaticSwiper,
  };
  eleObserver: Observer | null = null;
  isShowMobileValid = false;
  userInfo: IUserInfo = {
    activity_class_id: -1,
    InviterUserId: -1,
  };

  huabeiList: IHuabeiTermInfo[] = [];

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  huabeiTotalAmount = 0;

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  payTerm = 12; // 花呗默认期数

  isShowQuestionnaire = false;
  questionSurveyCode = '';

  questionCompMap = {
    python_class: QuestionnairePy,
    idp_class: QuestionnaireNormal,
  };

  @Watch('pageConfig')
  checkHasHuabei(newVal: IPageConfig) {
    const { payment_configs } = newVal;
    if (
      this.bottomConfig &&
      this.bottomConfig.type === BottomType.APPLY &&
      payment_configs &&
      Array.isArray(payment_configs) &&
      payment_configs.some(item => item === PayTypes.huabei)
    ) {
      this.getHuabeiTermInfo();
    }
  }

  @Watch('bottomConfig')
  checkQuestionnaire(newVal: IBottom) {
    const { type, config } = newVal;
    if (type === BottomType.COLLECT && (config as IBottomConfig)?.survey) {
      this.$nextTick(() => {
        if (
          this.pageConfig.button_color &&
          !this.pageConfig.button_color.includes('linear-gradient')
        ) {
          // 全局设置问卷主题色
          document.body.style.setProperty(
            '--ques-theme-bg',
            this.pageConfig.button_color
          );
          document.body.style.setProperty(
            '--ques-theme-bg-opacity',
            hexToRgba(this.pageConfig.button_color, 0.08)
          );
        }
        this.isShowQuestionnaire = true;
        this.questionSurveyCode = (config as IBottomConfig).survey!;
      });
    }
  }

  get hasMobileModule() {
    if (this.pageConfig && this.bottomConfig) {
      return (
        this!.pageConfig.mobile_check &&
        this.bottomConfig.type === 'apply' &&
        !this.pageConfig.mobile
      );
    }
    return false;
  }

  get validPhoneText() {
    if (this.bottomConfig.type === BottomType.APPLY) {
      return this.bottomConfig.config.button;
    }
    return '';
  }
  get isFreePrice() {
    if (this.bottomConfig.type === BottomType.APPLY) {
      const price = (this.bottomConfig?.config as IApplyConfig)?.price;
      const FREE_PRICE = 0;
      if (Number(price) === FREE_PRICE) {
        return true;
      }
    }
    return false;
  }

  async getHuabeiTermInfo() {
    try {
      const { data } = await window.apis.getHuabeiTermInfo({
        production_id: this.productionId,
        coupon_id: this.couponId,
      });
      const { plan, amount } = data;
      if (plan && Array.isArray(plan)) {
        this.huabeiList = plan;
      }
      amount && (this.huabeiTotalAmount = amount);
    } catch (error) { }
  }

  onChangeChannel(c: IPayType, term: number) {
    this.payConfig = c;
    term && (this.payTerm = term);
  }

  handleModelPageViewTrack() {
    if (this.pageConfig) {
      this.__initModelPageTrack();
    }
  }

  handleTrack() {
    const sensorData = this.pageConfig.sensor_data;
    const defaultPrice = 6.9;
    if (sensorData) {
      this.__initTrack({
        user_types: '体验课用户',
        wxapp_name: sensorData.wx_app_name || sensorData.wxapp_name,
        config: {
          production_id: this.productionId,
          production_type: sensorData.production_type,
          actual_price: Number(sensorData.actual_price) || defaultPrice,
        },
      });
    }
  }

  handleTrackResList() {
    const config = this.pageConfig.content;
    if (!config) return;

    this.$nextTick(() => {
      const eleList: { el: HTMLElement; title: string }[] = [];
      for (let i = 0; i < this.$refs.resList.length; i++) {
        const { $el } = this.$refs.resList[i];
        eleList.push({ el: $el, title: config[i].title });
      }
      this.__initTrackResList(eleList);
    });
  }

  handleValidSucces(phone: number) {
    this.pageConfig!.mobile = phone;
    this.handleApply();
  }

  handleGetCode() {
    this.__trackBtnClick({
      button_name: '获取验证码',
    });
  }

  checkMobile() {
    if (this.pageConfig!.mobile_check && !this.pageConfig!.mobile) {
      const ele = document.getElementById('mobile-wrapper');
      const el = document.getElementById('t-scroll-container');
      if (el && ele) {
        el.scrollTop = ele?.offsetTop;

        toast({ type: ToastType.first_level, value: '请先验证手机号' });
      }
      return false;
    }
    return true;
  }

  handleObserverMobile() {
    setTimeout(() => {
      const ele = document.getElementById('t-scroll-container');
      if (ele) {
        const phoneVm = document.getElementById('phone-validate');
        if (phoneVm) {
          const observer = new Observer(
            ele,
            () => {
              this.isShowMobileValid = true;
            },
            () => {
              this.isShowMobileValid = false;
            }
          );
          observer.observe(phoneVm);
          this.eleObserver = observer;
        }
      }
    });
  }

  async handleToPayPlatform() {
    try {
      await window.apis.postReportToPay(
        {
          production_id: this.productionId,
          url: window.location.href,
          coupon_id: this.couponId,
          // total_price: this.bottomConfig.config.price * 100,
        },
        {
          production_id: this.productionId,
        }
      );

      const query: any = {
        id: this.productionId,
        c_id: this.couponId,
      };

      this.$router.push({
        name: 'Cashier',
        params: {
          fromEnrollment: true,
        },
        query,
      });
    } catch (error) { }
  }

  @promiseLock
  handleApply() {
    this.handleStrategyTracker('landingpage_paid_enroll_click');
    this.handleStrategyFreeTracker('landingpage_free_enroll_click', {
      button_name: '免费报名',
    });

    if (!this.checkMobile()) {
      return;
    }

    this.__trackApplyClick({ button_name: '马上报名' });
    this.__closure2TrackerFreeClickTracker();

    if (!this.isFreePrice && this.pageConfig.payment_check) {
      this.handleToPayPlatform();

      return;
    }

    // 默认支付方法
    let payMethod = handlePayment;

    // 判断是否为iframe模式（自研直播间场景）
    if (this.$route.query.iframe_mode === 'livestream') {
      payMethod = handleIframePayment
    } else if (this.isFreePrice) {
      payMethod = this.handleFreePayment
    }

    // 分期参数
    const fenqiPayParams =
      this.payConfig.channel === PayChannel.huabei
        ? { hb_fq_num: this.payTerm }
        : {};

    // 传播模型报名页参数
    const communicationModelParams = this.handleCommunicationModelPramas();

    this.handleStrategyTracker('landingpage_paid_prepay');
    // 如果链接上带有c_id（有优惠券）,向后端发起记录请求
    return payMethod(
      this.productionId,
      {
        channel: this.payConfig.channel,
        mobile: this.pageConfig?.mobile,
      },
      this.priceCountDown > 0
        ? {
          ...this.$route.query,
          ...getQueryFromSearch(),
          use_coupon: false,
          ...fenqiPayParams,
          ...communicationModelParams,
        }
        : {
          ...this.$route.query,
          ...getQueryFromSearch(),
          ...fenqiPayParams,
          ...communicationModelParams,
        }
    )
      .then(() => {
        this.isShowMobileValid = false;
        this.eleObserver && this.eleObserver.unobserve();
        this.handleStrategyTracker('landingpage_paid_pay_status', {
          payment_status: '成功',
        });

        this.handleStrategyTracker('landingpage_enroll', {
          production_id: this.productionId,
          source_path: '直接支付',
        });
        return this.freshBottomConfig();
      })
      .catch((e: any) => {
        console.log('pay', e);
        this.onPayError(e);
      });
  }

  handleFreePayment(
    productionId: number,
    body: { channel: string;[key: string]: any },
    linkQuery: any
  ) {
    return window.apis
      .postFreePayCharge(body, { id: productionId }, linkQuery)
      .then(({ data }: { data: IFreeChageRes }) => {
        if (data && data.success) {
          this.__closure2TrackerFreeDoneTracker();
          return Promise.resolve();
        } else {
          return Promise.reject();
        }
      })
      .catch(() => {
        toast({ type: ToastType.first_level, value: '支付失败' });
        return Promise.reject();
      });
  }

  // 使用时记录
  async handleRecordCoupon() {
    const { c_id } = this.$route.query;
    if (!c_id) return;

    try {
      await window.apis.applyCoupon({
        c_id,
        url: window.location.href,
      });
    } catch (error) { }
  }

  handleSetPageTitle(title: string) {
    document.title = title || '风变编程';
  }

  onQuestionnaireFinish() {
    this.isShowQuestionnaire = false;
    this.freshBottomConfig();
  }

  handleCommunicationModelPramas() {
    // 当值存在则是传播模型报名页
    if (
      this.userInfo.activity_class_id > 0 &&
      this.userInfo.InviterUserId > 0
    ) {
      return {
        ...this.userInfo,
      };
    }
    return {};
  }

  @promiseLock
  handleReloadQrcode() {
    return this.freshBottomConfig();
  }

  async handlePostLongTouch() {
    if (
      this.bottomConfig.type === BottomType.ASSISTANT ||
      this.bottomConfig.type === BottomType.SUBSCRIBE
    ) {
      try {
        await window.apis.postLongTouch({
          action: this.bottomConfig.type, // subscribe  assistant
          production_id: this.productionId,
        });
      } catch (e) { }
    }
  }
}
